import { render, staticRenderFns } from "./Promotion.vue?vue&type=template&id=206cfbc1&scoped=true&"
import script from "./Promotion.vue?vue&type=script&lang=js&"
export * from "./Promotion.vue?vue&type=script&lang=js&"
import style0 from "./Promotion.vue?vue&type=style&index=0&id=206cfbc1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "206cfbc1",
  null
  
)

export default component.exports